import { render, staticRenderFns } from "./ChangeUserEmailModal.vue?vue&type=template&id=5f134635&"
import script from "./ChangeUserEmailModal.vue?vue&type=script&lang=js&"
export * from "./ChangeUserEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports